import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi } from 'ag-grid-community';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { ToastrService } from 'ngx-toastr';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { MasterService } from 'src/app/masters/master.service';
import { Parameter } from 'src/app/common/grid-utils/parameter.model';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';
import { SharedService } from 'src/app/utils/shared.service';
import { AddTreatmentComponent } from '../treatment/add-treatment.component';
import * as CommonConstants from '../../utils/common.constants';
import swal from 'sweetalert2';
import { LoaderService } from 'src/app/common/loader.service';
@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {

  medFileForm: FormGroup;
  @Input() patieId;
  @Input() selectedMedFile;
  gridApi: GridApi;
  personalGridApi: GridApi;
  diagnosticAssociates = [];
  personalList = [];
  medicationtList = [];
  frameworkComponents;
  status;
  diagnosticDefs;
  personalDefs;
  diagnosticRowData = [];
  personalRowData = [];
  PARAM_KEY=[CommonConstants.TREATMENT_TYPE,CommonConstants.STATUS];
  masterValues=[];
  submitted=false;
  treatmentTypes;
  defaultColDef = {
    editable: true,
    singleClickEdit: true,
    resizable: true,
    sortable:true,
    filter:true,
  }
  medicalFileDtls;
  snomedTerm;
  @Input() medFileId;
  //add medication 
preSelectedSnomed;
  @ViewChild(AddTreatmentComponent, { static: false }) childTreatment: AddTreatmentComponent;
  diagnosticGridColumnApi: any;
  personalGridColumnApi: any;
  fileStatus: string;
  selectedSnomed: any=[];
  snomedResults: any;
  constructor(private modal: NgbModal, private fb: FormBuilder, private medFileService: MedicalFileService
    , private toastrService: ToastrService,private loaderService:LoaderService, private masterService: MasterService, private sharedService: SharedService) {
    this.getFormGroup();
    this.frameworkComponents = {
      ngSelectEditor: GridNgSelectDataComponent,
      agDateInput: CustomDateComponent
    }
    this.fileStatus=localStorage.getItem(CommonConstants.FILE_STATUS);
  }

  ngOnInit() {
    if(!this.patieId){
      this.medFileForm.disable();
    }
    this.loadMaster();
  }

 
  getPersonalGrid() {
    this.personalDefs = [
      { headerName: 'statuCode', field: 'statuCode', hide: true },
      { headerName: 'Diagnostic', field: 'medfiId', hide: true },
      { headerName: 'Diagnostic', field: 'medapVaDiagnostic', },
      { headerName: 'Description', field: 'medapVaDesc' },
      { headerName: 'Discovery Date', field: 'medapDtDiscovery', cellEditor: 'agDateInput' },
      { headerName: 'From', field: 'medapDtFrom', cellEditor: 'agDateInput' },
      { headerName: 'To', field: 'medapDtTo', cellEditor: 'agDateInput' },
      { headerName: 'treatCode', field: 'treatCode', hide: true },
      {
        headerName: 'Treatment', field: 'treatment', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.treatmentTypes, dataColumn: 'treatCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
      {
        headerName: 'Status', field: 'status', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'Comment', field: 'medapDtComment' }
    ];

  }

  getDiagnosticGrid() {
    //add diagnotic 
    this.diagnosticDefs = [
      { headerName: 'statuCode', field: 'statuCode', hide: true },
      { headerName: 'Diagnostic', field: 'medapVaDiagnostic', },
      { headerName: 'Description', field: 'meddaVaDesc' },
      { headerName: 'Discovery Date', field: 'meddaDtFrom', cellEditor: 'agDateInput' },
      { headerName: 'There is About', field: 'meddaVaThereIsAbout' },
      { headerName: 'Recovery Date', field: 'meddaDtRecevery', cellEditor: 'agDateInput' },
      {
        headerName: 'Status', field: 'description', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'treatCode', field: 'treatCode', hide: true },
      {
        headerName: 'Treatment', field: 'treatment', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.treatmentTypes, dataColumn: 'treatCode', model: new Parameter(), objectData: ['id', 'value'] }
      }
    ];
  }

  private getFormGroup() {
    this.medFileForm = this.fb.group({
      'patieId': new FormControl(),
      'medfiId': new FormControl(),
      'medfiVaMainDiagnostic': ['', Validators.required],
      'medfiVaDescription': new FormControl(),
      'medfiVaHistoryEvolution': new FormControl(),
    })
  }

  get f() { return this.medFileForm.controls; }

  loadMaster() {
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterValues = response['result'];
        this.treatmentTypes=this.masterValues.filter(master => master.paramKey === CommonConstants.TREATMENT_TYPE);
        this.status=this.masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
        this.medFileService.getMedFiles(this.medFileId).subscribe(res => {
          if (res && res["result"]) {
            let response = res["result"];
            this.medicalFileDtls = response;
            this.medFileForm.patchValue(this.medicalFileDtls);
            this.diagnosticAssociates =  this.setMasterMapping(response["diagnosticAssociates"]);
            this.personalList = this.setMasterMapping(response["personalAtcd"]);
           // this.selectedSnomed=this.setMasterMapping(response["snomeds"]);
           this.selectedSnomed=[];
            for(let item of response["snomeds"]){
              let obj={};
              let fsn={};
              fsn["term"]=item["snomedDesc"];
              obj["fsn"]=fsn;
              this.selectedSnomed.push(obj);
            }
          }
        })
      }
    });
  }

  addnewDiagnosticModal(addDiagnostic) {
    this.diagnosticRowData = [];
    this.modal.open(addDiagnostic, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    if (!this.diagnosticDefs) {
      this.getDiagnosticGrid();
    }
  }
  addnewPersonalModal(modalId) {
    this.personalRowData = [];
    this.modal.open(modalId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    if (!this.personalDefs) {
      this.getPersonalGrid();
    }
  }

  addNewDiagnostic() {
    //  this.diagnosticRowData = [];
    const newRow = { statuCode: '', medapVaDiagnostic: '', meddaVaDesc: '', meddaVaThereIsAbout: '', meddaDtRecevery: '', description: '', treatCode: '' };
    this.diagnosticRowData.unshift(newRow);
    this.gridApi.setRowData(this.diagnosticRowData);
  }
  addNewPersonal() {
    //this.personalRowData = [];
    const newRow = { statuCode: '',medapVaDiagnostic: '', medapVaDesc: '', medapDtDiscovery: '', medapDtComment: '', description: '', treatCode: '' };
    this.personalRowData.unshift(newRow);
    this.personalGridApi.setRowData(this.personalRowData);
  }


  onGridReadyDiagnostic(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
   // this.diagnosticGridColumnApi = params.columnApi;
    //this.sharedService.autoSizeAll(this.diagnosticGridColumnApi);
  }
  onGridReadyPersonal(params) {
    this.personalGridApi = params.api;
    this.personalGridApi.sizeColumnsToFit();
    //this.personalGridColumnApi = params.columnApi;
    //this.sharedService.autoSizeAll(this.personalGridColumnApi);
  }


  saveMedicalFiles() {
    this.submitted = true;
    if (this.medFileForm.invalid) {
      return;
    }
    this.medFileForm.patchValue({ patieId: this.patieId });
    let jsonData=null;
    if(this.medicalFileDtls){
      jsonData=this.medicalFileDtls;
      jsonData["medfiVaMainDiagnostic"]=this.medFileForm.value.medfiVaMainDiagnostic;
      jsonData["medfiVaDescription"]=this.medFileForm.value.medfiVaDescription;
      jsonData["medfiVaHistoryEvolution"]=this.medFileForm.value.medfiVaHistoryEvolution;
    }else{
      jsonData=this.medFileForm.value;
    }
    let snomedList=[];
    if(this.selectedSnomed && this.selectedSnomed.length >0){
      for(let item of this.selectedSnomed){
      let snomed={
        snomedId:item.conceptId,
        snomedDesc:item.fsn.term
      }
      snomedList.push(snomed);
    }
    }
    jsonData["snomeds"]=snomedList;
    this.loaderService.display(true);
    this.medFileService.saveMedFiles(jsonData).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        let response = res["result"];
        this.sharedService.nextMedicalFiledId(response.medfiId);
        this.sharedService.medicalFileStatus('NEW');
        localStorage.setItem(CommonConstants.FILE_STATUS, 'NEW');
        this.medFileForm.patchValue({ medfiId: response.medfiId });
        //this.toastrService.success("Saved Successfully");
        swal.fire("Success",response['message'],'success');

      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error","Error Occured While Saving Medical File",'error');
    })
  }

  saveDiagnostic() {
    this.diagnosticRowData = this.diagnosticRowData.map(item => ({
      ...item,
      'medfiId': this.medFileForm.get('medfiId').value
    }));
    this.medFileService.saveDiagnostics(this.diagnosticRowData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Saved Succesffully");
        if (res["result"][0])
          this.diagnosticAssociates.unshift(this.setMasterMapping(res["result"][0]));
          this.diagnosticAssociates = Object.values(this.diagnosticAssociates.reduce((acc,c)=>(acc[c.meddaId]=c,acc),{}));
        this.diagnosticAssociates = [...this.diagnosticAssociates];
        this.modal.dismissAll();
      }
    })
  }

  savePersonal() {
    this.personalRowData = this.personalRowData.map(item => ({
      ...item,
      'medfiId': this.medFileForm.get('medfiId').value
    }));
    this.medFileService.savePersonals(this.personalRowData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Saved Succesffully");
        if (res["result"][0])
          this.personalList.unshift(this.setMasterMapping(res["result"][0]));
          this.personalList = Object.values(this.personalList.reduce((acc,c)=>(acc[c.medapId]=c,acc),{}));
        this.personalList = [...this.personalList];
        this.modal.dismissAll();
      }
    })
  }

  onDiagnosticAssociatesRowSelect(addDiagnostic) {
    if(this.fileStatus==='NEW'){
    this.getDiagnosticGrid();
    this.modal.open(addDiagnostic, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.diagnosticRowData = this.diagnosticAssociates;
    }
  }

  onPersonalRowSelect(modalId) {
    if(this.fileStatus==='NEW'){
    this.getPersonalGrid();
    this.modal.open(modalId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.personalRowData = this.personalList;
    }
  }


  resetMedicalFile() {
    this.medFileForm.reset();
    this.diagnosticAssociates = [];
    this.personalList = [];
  }

  setMasterMapping(list) {
    if (list) {
      if (Array.isArray(list)) {
        list = list.map(item => ({
          ...item,
          status: item.statuCode ? this.status.find(obj => +obj.id === +item.statuCode).value : null,
          treatment: item.treatCode ? this.treatmentTypes.find(obj => +obj.id === +item.treatCode).value : null,
        }));
      } else {
        list = {
          ...list,
          status: list['statuCode'] ? this.status.find(obj => +obj.id === +list['statuCode']).value : null,
          treatment: list['treatCode'] ? this.treatmentTypes.find(obj => +obj.id === +list['treatCode']).value : null
        }
      }
    }
    return list;
  }
  searchSnomed(snomed){
    this.modal.open(snomed, { container: '.page-content' });
    this.snomedTerm=this.medFileForm.value.medfiVaMainDiagnostic;
  }
  searchSnomedDetails(){
    let searchdata={
      "term":this.snomedTerm,
      "ecl":"<<404684003",
      "limit":50,
      "offset":0
    }
    this.loaderService.display(true);
    this.medFileService.searchSnomed(searchdata).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        this.snomedResults=res["result"]["body"]["items"];
      }
    },
    error => {
      this.loaderService.display(false);
      swal.fire("Error","Error Occured While Fetching SNOMED data",'error');
    })
  }
  addSnomed(){
    this.selectedSnomed=[];
    for(let item of this.preSelectedSnomed){
      this.selectedSnomed.push(item);
    }
    this.modal.dismissAll();
  }
}
